import SourceListItem from './SourceListItem';

import './SourceListItem.scss';

export default SourceListItem;
